'use strict'

var Marionette = require('marionette')
var App = require('app')

var ListComponent = require('src/components/list-view')
var PageBodyComponent = require('src/components/page-body-view')

var LayoutView = PageBodyComponent.Layout.extend({})

module.exports.layout = LayoutView

// -----
var ListItem = ListComponent.ItemView.extend({
  // template: require('./templates/item.html')
  templateContext: function () {
    var self = this
    return {
      getListColumns: function () {
        return self.options.columns
      },
      getHideClasses: App.TemplateHelpers.getHideClasses(self.options),                   
      getColumnField: function (field) {
        var value = _.get(this, field)

        switch (field) {
          case 'type':
            return App.TemplateHelpers.getDeviceTypeLabel(value)
            break
          case 'createdAt':
            return App.TemplateHelpers.formatTime(value)
            break
          default:
            return value
            break
        }
      }
    }
  }
})
module.exports.listItem = ListItem

// -- List Component which supports paginating and bulk edit
var listView = ListComponent.ListView.extend({})

module.exports.listView = listView




// WEBPACK FOOTER //
// ./js/modules/client-groups/list/view.js